import state from "@/store/modules/employee/state";
import actions from "@/store/modules/employee/actions";
import mutations from "@/store/modules/employee/mutations";
import getters from "@/store/modules/employee/getters";

export default {
    state,
    actions,
    mutations,
    getters
}
